import {
  CHINA_COUNTRY_CODE,
  INDIA_COUNTRY_CODE,
} from '@packages/domain/constants/countries';
import { EU_COUNTRY_CODES } from '@packages/domain/constants/geolocation';
import type { RootState } from 'reducers/types';

export const isEUMemberAccess = (state: RootState) => {
  const {
    geolocation: { countryCode },
  } = state;

  return EU_COUNTRY_CODES.includes(countryCode);
};

export const getCountryCode = (state: RootState) => {
  const { geolocation: { countryCode = null } = {} } = state;

  return countryCode;
};

export const isIndiaIpAddress = (state: RootState) => {
  const countryCode = getCountryCode(state);

  if (!countryCode) {
    return false;
  }

  return countryCode.toUpperCase() === INDIA_COUNTRY_CODE;
};

export const isChinaIpAddress = (state: RootState) => {
  const countryCode = getCountryCode(state);

  if (!countryCode) {
    return false;
  }

  return countryCode.toUpperCase() === CHINA_COUNTRY_CODE;
};
